export const footer = {
    french: {
        title: "Site réalisé par Nicolas Duquesne"
    }
}